var _defs, _g, _rect, _rect2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCalendar01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40.8 40.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8,
    height: 40.8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8,
    height: 40.8,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8,
    height: 40.8,
    rx: 8,
    ry: 8,
    fill: "#f2642a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.1401,13.404c.471,0,.852-.382.852-.852v-3.163c0-.471-.381-.853-.852-.853s-.852.382-.852.853v3.163c0,.47.381.852.852.852",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.1401,13.404c.471,0,.852-.382.852-.852v-3.163c0-.471-.381-.853-.852-.853s-.852.382-.852.853v3.163c0,.47.381.852.852.852Z",
    fill: "none",
    stroke: "#f2642a",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.3794,30.5587H11.4204c-.846,0-1.534-.774-1.534-1.726v-11.774h21.028v11.774c0,.952-.689,1.726-1.535,1.726m0-20.412h-1.705v1.705h1.705c.846,0,1.535.774,1.535,1.726v1.776H9.8864v-1.776c0-.952.688-1.726,1.534-1.726h1.705v-1.705h-1.705c-1.786,0-3.239,1.539-3.239,3.431v15.255c0,1.892,1.453,3.431,3.239,3.431h17.959c1.786,0,3.24-1.539,3.24-3.431v-15.255c0-1.892-1.454-3.431-3.24-3.431",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.3794,30.5587H11.4204c-.846,0-1.534-.774-1.534-1.726v-11.774h21.028v11.774c0,.952-.689,1.726-1.535,1.726Zm0-20.412h-1.705v1.705h1.705c.846,0,1.535.774,1.535,1.726v1.776H9.8864v-1.776c0-.952.688-1.726,1.534-1.726h1.705v-1.705h-1.705c-1.786,0-3.239,1.539-3.239,3.431v15.255c0,1.892,1.453,3.431,3.239,3.431h17.959c1.786,0,3.24-1.539,3.24-3.431v-15.255c0-1.892-1.454-3.431-3.24-3.431Z",
    fill: "none",
    stroke: "#f2642a",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.195,
    y: 10.147,
    width: 8.411,
    height: 1.705,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.195,
    y: 10.147,
    width: 8.411,
    height: 1.705,
    fill: "none",
    stroke: "#f2642a",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-1)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.6598,13.404c.471,0,.853-.382.853-.852v-3.163c0-.471-.382-.853-.853-.853s-.852.382-.852.853v3.163c0,.47.381.852.852.852",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.6598,13.404c.471,0,.853-.382.853-.852v-3.163c0-.471-.382-.853-.853-.853s-.852.382-.852.853v3.163c0,.47.381.852.852.852Z",
    fill: "none",
    stroke: "#f2642a",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.198,21.8482h-1.595v-1.577h1.595v1.577Zm.724-3.026h-3.044c-.4,0-.724.324-.724.724v3.026c0,.401.324.725.724.725h3.044c.4,0,.724-.324.724-.725v-3.026c0-.4-.324-.724-.724-.724",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.198,21.8482h-1.595v-1.577h1.595v1.577Zm.724-3.026h-3.044c-.4,0-.724.324-.724.724v3.026c0,.401.324.725.724.725h3.044c.4,0,.724-.324.724-.725v-3.026c0-.4-.324-.724-.724-.724Z",
    fill: "none",
    stroke: "#f2642a",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.2014,21.8482h-1.595v-1.577h1.595v1.577Zm.724-3.026h-3.044c-.4,0-.724.324-.724.724v3.026c0,.401.324.725.724.725h3.044c.4,0,.724-.324.724-.725v-3.026c0-.4-.324-.724-.724-.724",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.2014,21.8482h-1.595v-1.577h1.595v1.577Zm.724-3.026h-3.044c-.4,0-.724.324-.724.724v3.026c0,.401.324.725.724.725h3.044c.4,0,.724-.324.724-.725v-3.026c0-.4-.324-.724-.724-.724Z",
    fill: "none",
    stroke: "#f2642a",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.1946,21.8482h-1.595v-1.577h1.595v1.577Zm.724-3.026h-3.044c-.4,0-.724.324-.724.724v3.026c0,.401.324.725.724.725h3.044c.4,0,.724-.324.724-.725v-3.026c0-.4-.324-.724-.724-.724",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.1946,21.8482h-1.595v-1.577h1.595v1.577Zm.724-3.026h-3.044c-.4,0-.724.324-.724.724v3.026c0,.401.324.725.724.725h3.044c.4,0,.724-.324.724-.725v-3.026c0-.4-.324-.724-.724-.724Z",
    fill: "none",
    stroke: "#f2642a",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.198,27.4771h-1.595v-1.577h1.595v1.577Zm.724-3.026h-3.044c-.4,0-.724.324-.724.724v3.026c0,.401.324.725.724.725h3.044c.4,0,.724-.324.724-.725v-3.026c0-.4-.324-.724-.724-.724",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.198,27.4771h-1.595v-1.577h1.595v1.577Zm.724-3.026h-3.044c-.4,0-.724.324-.724.724v3.026c0,.401.324.725.724.725h3.044c.4,0,.724-.324.724-.725v-3.026c0-.4-.324-.724-.724-.724Z",
    fill: "none",
    stroke: "#f2642a",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.1946,27.4771h-1.595v-1.577h1.595v1.577Zm.724-3.026h-3.044c-.4,0-.724.324-.724.724v3.026c0,.401.324.725.724.725h3.044c.4,0,.724-.324.724-.725v-3.026c0-.4-.324-.724-.724-.724",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.1946,27.4771h-1.595v-1.577h1.595v1.577Zm.724-3.026h-3.044c-.4,0-.724.324-.724.724v3.026c0,.401.324.725.724.725h3.044c.4,0,.724-.324.724-.725v-3.026c0-.4-.324-.724-.724-.724Z",
    fill: "none",
    stroke: "#f2642a",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendar01);
export default __webpack_public_path__ + "static/media/ico-calendar-01.0001fb21963ad80eb9c681d33408423a.svg";
export { ForwardRef as ReactComponent };